import React from "react";
import { Select } from "antd";

import { PRIORITY_OPTIONS } from "../../constants/projects.constants";

import type { IssuePriority } from "../../../../core/data/redux/projects/types";

interface PriorityPickerProps {
  value: IssuePriority | null | undefined;
  onChange: (priority: IssuePriority) => void;
  disabled?: boolean;
  size?: "small" | "middle" | "large";
}

const PriorityPicker: React.FC<PriorityPickerProps> = ({
  value,
  onChange,
  disabled,
  size = "middle",
}) => {
  return (
    <Select
      style={{ width: "100%", height: 36 }}
      value={value ?? undefined}
      onChange={(v) => onChange(v as IssuePriority)}
      disabled={disabled}
      size={size}
      placeholder="Priority"
      options={PRIORITY_OPTIONS.map((p) => ({
        value: p.value,
        label: (
          <span className="d-inline-flex align-items-center gap-2">
            <span
              className="d-inline-block rounded-circle"
              style={{ width: 8, height: 8, background: p.color }}
            />
            {p.label}
          </span>
        ),
      }))}
    />
  );
};

export default PriorityPicker;
